import React from "react";
import {
    Modal,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
} from "@heroui/react";


export default function DateRangModal({
    title,
    children,
    isOpen,
    onClose,
}) {
    return (
        <>
            {/* <Button onPress={onOpen}>Open Modal</Button> */}
            <Modal backdrop='blur' hideCloseButton size="3xl" isOpen={isOpen} onClose={onClose} isDismissable={true} isKeyboardDismissDisabled={true} >
                <ModalContent>
                    {(onClose) => (
                        <>
                            <ModalHeader className="flex flex-col gap-1 border-b border-gray-100">
                                {title}
                            </ModalHeader>
                            <ModalBody className="p-0 py-4 px-6">
                                {children}
                            </ModalBody>
                            <ModalFooter className="border-t border-gray-100">
                                <Button color="primary" variant="flat" onPress={onClose}>
                                    <p className="text-primary-900">Close</p>
                                </Button>
                            </ModalFooter>
                        </>
                    )}
                </ModalContent>
            </Modal>
        </>
    );
}